import { find } from "lodash";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet, useLocation, useParams } from "react-router-dom";
import { Tag } from "../../App/components/atoms";
import { listenToLocation1688FromFirestore } from "../../App/firestore/firestoreService";
import { userFirestoreDoc } from "../../App/hooks/useFirestoreDoc";
import { AdminPage } from "../../App/layout/AdminPage/AdminPage";
import { listenToSelectedLocation1688 } from "../../App/redux/data/location1688/location1688Actions";

const currentMenu = (id: string) => [
  // appendRouteHere
  {
    key: "mainDetails",
    label: "Main details",
    link: `/production-line/${id}/mainDetails`,
  },
  {
    key: "users",
    label: "Users",
    link: `/production-line/${id}/users`,
  },
  {
    key: "orderLists",
    label: "Order list",
    link: `/production-line/${id}/orderLists`,
  },
  {
    key: "suggestion-orders",
    label: "Suggestion Orders",
    link: `/production-line/${id}/suggestion-orders`,
  },

  {
    key: "returnLists",
    label: "Return lists",
    link: `/production-line/${id}/returnLists`,
  },
  {
    key: "goodsReceived",
    label: "Goods received",
    link: `/production-line/${id}/goodsReceived`,
  },
  {
    key: "productions",
    label: "Productions",
    link: `/production-line/${id}/productions`,
  },
  {
    key: "baked-stock",
    label: "Baked Stock",
    link: `/production-line/${id}/baked-stocks`,
  },
  {
    key: "raw-stock",
    label: "Raw Stock",
    link: `/production-line/${id}/raw-stocks`,
  },
];
const currentBreadcrumb = (name: string) => [
  {
    key: "page",
    label: name,
    link: "#",
  },
];

const ProductionLinePage: React.FC = () => {
  const location = useLocation();
  const params = useParams();
  const dispatch = useDispatch();
  const [pageName, setPageName] = React.useState<string>("");
  const [breadcrumb, setBreadcrumb] = React.useState<any[]>([]);
  const productionLineId = params.productionLineId || "";
  const headerMenu = currentMenu(productionLineId);
  const { selectedLocation1688 } = useSelector(
    (state: any) => state.location1688
  );
  userFirestoreDoc({
    query: () => listenToLocation1688FromFirestore(productionLineId),
    data: listenToSelectedLocation1688,
    deps: [dispatch, productionLineId],
  });

  React.useEffect(() => {
    const name = find(headerMenu, ["link", location.pathname]);
    setBreadcrumb(currentBreadcrumb(name?.label || "") || []);
    setPageName(name?.label || "");
  }, [location.pathname]);

  return (
    <AdminPage
      title={
        <div className="admin-page-title">
          ProductionLine: {selectedLocation1688?.name} <Tag>{pageName}</Tag>
        </div>
      }
      headerMenu={headerMenu}
      breadcrumb={breadcrumb}
    >
      <Outlet />
    </AdminPage>
  );
};

export default ProductionLinePage;
